import type { ProethicaTestKind } from "@constants/demo/proethica-tests";
import { useAppTheme } from "@hooks/useAppTheme";
import { Image } from "expo-image";

const TEST_IMAGES: Record<ProethicaTestKind, number> = {
	pretest: require("../../../assets/praxis-proethica/modules/pretest-graphic-badge-transparent.png"),
	posttest: require("../../../assets/praxis-proethica/modules/posttest-graphic-badge-transparent.png"),
};

type Props = {
	kind: ProethicaTestKind;
	size?: number;
	locked?: boolean;
};

export const ProethicaTestBadge = ({ kind, size = 72, locked }: Props) => {
	const theme = useAppTheme();

	return (
		<Image
			source={TEST_IMAGES[kind]}
			style={{
				width: size,
				height: size,
				borderRadius: theme.roundness,
				opacity: locked ? 0.5 : 1,
			}}
			contentFit="contain"
		/>
	);
};
